import { SortParams } from 'dashboard/lib/interfaces/SortParams';
import { CheckStatus } from 'dashboard/models/check';
import { Environment } from 'dashboard/models/environment';
import { Verification } from 'dashboard/models/verification';
import Action from 'lib/interfaces/Action';
import { PaginationParams } from 'lib/interfaces/api';
import { Iso8601DateString } from 'lib/types';
import { VerificationStatus } from 'lib/verification';
import { CheckName } from 'lib/verificationCheck';

export type VerificationsActions =
  | Action<VerificationsActionType.SetVerifications, SetVerificationsPayload>
  | Action<VerificationsActionType.SetCurrentPage, SetCurrentPagePayload>
  | Action<VerificationsActionType.SetPageSize, SetPageSizePayload>
  | Action<VerificationsActionType.SetFilters, SetFiltersPayload>
  | Action<VerificationsActionType.SetSortParams, SetSortParamsPayload>;

export enum VerificationsActionType {
  SetVerifications = 'verifications/SET_VERIFICATIONS',
  SetCurrentPage = 'verifications/SET_CURRENT_PAGE',
  SetPageSize = 'verifications/SET_PAGE_SIZE',
  SetFilters = 'verifications/SET_FILTERS',
  SetSortParams = 'verifications/SET_SORT_PARAMS',
}

export interface CheckFilterValues {
  check: CheckName;
  status: CheckStatus;
}

export interface VerificationsFilterParams {
  omni?: string;
  createdAtStart?: Iso8601DateString;
  createdAtEnd?: Iso8601DateString;
  updatedAtStart?: Iso8601DateString;
  updatedAtEnd?: Iso8601DateString;
  status?: VerificationStatus[];
  type?: Verification['type'][];
  tagIds?: string[];
  issuingCountries?: string[];
  issuingSubdivisions?: string[];
  governmentIdTypes?: string[];
  checks?: CheckFilterValues[];
  inquiryTemplateIds?: string[];
  verificationTemplateIds?: string[];
}

interface SetVerificationsPayload {
  verifications: Verification[];
  environment: Environment;
  paginationParams: PaginationParams;
}

export function setVerifications(
  verifications: Verification[],
  environment: Environment,
  paginationParams: PaginationParams,
): Action<VerificationsActionType.SetVerifications, SetVerificationsPayload> {
  return {
    payload: {
      verifications,
      environment,
      paginationParams,
    },
    type: VerificationsActionType.SetVerifications,
  };
}

interface SetCurrentPagePayload {
  currentPage: number;
}

export function setCurrentPage(
  currentPage: number,
): Action<VerificationsActionType.SetCurrentPage, SetCurrentPagePayload> {
  return {
    payload: {
      currentPage,
    },
    type: VerificationsActionType.SetCurrentPage,
  };
}

interface SetPageSizePayload {
  pageSize: number;
}

export function setPageSize(
  pageSize: number,
): Action<VerificationsActionType.SetPageSize, SetPageSizePayload> {
  return {
    payload: {
      pageSize,
    },
    type: VerificationsActionType.SetPageSize,
  };
}

interface SetFiltersPayload {
  filters: VerificationsFilterParams;
}

export function setFilters(
  filters: VerificationsFilterParams,
): Action<VerificationsActionType.SetFilters, SetFiltersPayload> {
  return {
    payload: {
      filters,
    },
    type: VerificationsActionType.SetFilters,
  };
}

interface SetSortParamsPayload {
  sortParams: SortParams;
}

export function setSortParams(
  sortParams: SortParams,
): Action<VerificationsActionType.SetSortParams, SetSortParamsPayload> {
  return {
    payload: {
      sortParams,
    },
    type: VerificationsActionType.SetSortParams,
  };
}
